import { render } from "./RoleInfo.vue?vue&type=template&id=19a7b41e"
import script from "./RoleInfo.vue?vue&type=script&lang=js"
export * from "./RoleInfo.vue?vue&type=script&lang=js"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__